interface Props {
  className?: string;
}

export default function PromotionIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 224 224"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M218.15 105.18L118.83 5.86009C116.978 3.9961 114.775 2.5183 112.348 1.51238C109.92 0.506449 107.318 -0.00758307 104.69 8.45319e-05H12.0001C8.81749 8.45319e-05 5.76524 1.26437 3.5148 3.5148C1.26437 5.76524 8.45319e-05 8.81749 8.45319e-05 12.0001V104.69C-0.00758307 107.318 0.506449 109.92 1.51238 112.348C2.5183 114.775 3.9961 116.978 5.86009 118.83L105.18 218.15C108.931 221.9 114.017 224.006 119.32 224.006C124.623 224.006 129.71 221.9 133.46 218.15L218.15 133.46C221.9 129.71 224.006 124.623 224.006 119.32C224.006 114.017 221.9 108.931 218.15 105.18ZM119.32 198.35L24.0001 103V24.0001H103L198.32 119.32L119.32 198.35ZM76.0001 60.0001C76.0001 63.1646 75.0617 66.258 73.3036 68.8892C71.5455 71.5204 69.0466 73.5712 66.123 74.7822C63.1994 75.9932 59.9823 76.31 56.8786 75.6926C53.7749 75.0753 50.924 73.5514 48.6864 71.3138C46.4487 69.0761 44.9249 66.2252 44.3075 63.1215C43.6902 60.0178 44.007 56.8008 45.218 53.8772C46.429 50.9535 48.4798 48.4547 51.111 46.6966C53.7421 44.9385 56.8356 44.0001 60.0001 44.0001C64.2435 44.0001 68.3132 45.6858 71.3138 48.6864C74.3144 51.687 76.0001 55.7566 76.0001 60.0001Z"
        fill="currentColor"
      />
    </svg>
  );
}
